import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, NavMenu, Loading } from '../../components';
import './Transactions.scss';
import WalletCard from '../../components/transactions/walletCard/WalletCard';
import GlobalCard from '../../components/transactions/globalCard/GlobalCard';
import TransactionList from '../../components/transactions/transactionList/TransactionList';
import { useErrorsContext } from '../../contexts/ErrorsContext';
import { getCard } from '../../services/transactionsService';
import { useHistory, useParams } from 'react-router-dom';
import { useParametrics } from '../../contexts/ParametricsContext';

const CREATOR_WALLET = 'CREATOR';

const Transactions = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [show, setShow] = useState(false);
  const { convocationId } = useParametrics();
  const [loading, setLoading] = useState(true);
  const [cardholderId] = useState(null);
  const [list, setList] = useState([]);
  const [globalBalance, setGlobalBalance] = useState(0);
  const [cardStatus, setCardStatus] = useState('');
  const [isCreator, setIsCreator] = useState(false);
  const {showError} = useErrorsContext();

  const { petitionId } = useParams();

  const _getBalances = async () => {
    try {
      setLoading(true);
      const cardInfo = await getCard(convocationId, petitionId);
      const creator = cardInfo['supportType'] === 'CREATOR';
      setIsCreator(creator);

      const wallets = cardInfo["balance"]?.["wallets"] ?? [];
      if (!creator) {
        const items = [
          {
            id: 'LIVE_ARTS',
            image: '/misc/icons/transactions/eventos-culturales.svg',
            title: 'Eventos culturales',
            balance: (wallets.find(b => b['wallet'] === 'LIVE_ARTS')?.['amount']?.['available'] ?? 0)
          },
          {
            id: 'DIGITAL_SUPPORT',
            image: '/misc/icons/transactions/consumo-digital.svg',
            title: 'Consumo digital',
            balance: (wallets.find(b => b['wallet'] === 'DIGITAL_SUPPORT')?.['amount']?.['available'] ?? 0)
          },
          {
            id: 'PHYSICAL_SUPPORT',
            image: '/misc/icons/transactions/productos-fisicos.svg',
            title: 'Productos físicos',
            balance: (wallets.find(b => b['wallet'] === 'PHYSICAL_SUPPORT')?.['amount']?.['available'] ?? 0)
          },
        ];
        setList(items);
        setGlobalBalance(items.reduce((val, item) => item.balance + val, 0));
      } else {
        setGlobalBalance(wallets.reduce((sum, w) => sum + (w['amount']?.['available'] ?? 0), 0));
      }

      setCardStatus(cardInfo['status']['statusDescription']);
    } catch(e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!convocationId) return;
    if (!petitionId) return history.goBack();
    setShow(true);
    _getBalances()
  }, [convocationId]) // eslint-disable-line

  return (
    <NavMenu>
      {show && (loading ? (
        <div className="vh-100 d-flex justify-content-center align-items-center">
          <Loading />
        </div>
      ) : (
        <div className="Transactions">
          <div className="Transactions__content">
            <div className="w-100 d-flex justify-content-center">
              <div className="header">
                <Button
                  icon="/misc/icons/arrow-left-blue.svg"
                  action={() => history.goBack()}
                  className="p-2 button-only-icon me-2"
                  a11y={t('Globals.return')}
                />
                <h1>{t('Transactions.title')} </h1>
              </div>
            </div>
            <div className='Transactions__content__global'>
              <GlobalCard
                balance={globalBalance}
                statusTitle={cardStatus}
              />
            </div>
            {isCreator ? (
              <TransactionList petitionId={petitionId} wallet={CREATOR_WALLET} />
            ) : (
              <div className="Transactions__content__list">
                <h2 className="Transactions__content__list__title">{t('Transactions.myWallets')}</h2>
                {!list || list.length < 1 ? (
                  <div className="Transactions__content__list__empty">
                    <img src="/misc/icons/transactions-empty.png" alt="icon" />
                    <span>{t('Transactions.noData')}</span>
                  </div>
                ) : (
                  list?.map((item, index) => <WalletCard
                    key={index}
                    id={item.id}
                    image={item.image}
                    title={item.title}
                    balance={item.balance}
                    cardholderId={cardholderId}
                    petitionId={petitionId}
                  />)
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </NavMenu>
  );
};

export default Transactions;
